import httpService from '../../../core/services/HttpService';

export interface PaymentInstruction {
  id: number | null;
  employee_id?: number;
  iban_masked: string;
  last3: string;
  bic: string;
  holder_name: string;
  bank_name: string;
  active: boolean;
  active_from: string | null;
  created_at: string | null;
}

export interface PaymentInstructionCreatePayload {
  iban: string;
  bic?: string;
  holder_name: string;
  bank_name?: string;
  active_from?: string;
}

class PaymentInstructionService {
  async getPaymentInstruction(employeeId: number): Promise<PaymentInstruction | null> {
    try {
      const response = await httpService.get<PaymentInstruction>(
        `/api/admin/employees/${employeeId}/payment-instruction/`
      );
      return response.data;
    } catch (error: any) {
      if (error?.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }

  async getMyPaymentInstruction(): Promise<PaymentInstruction | null> {
    try {
      const response = await httpService.get<PaymentInstruction>(
        '/api/employees/me/payment-instruction/'
      );
      return response.data;
    } catch (error: any) {
      if (error?.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }

  async createPaymentInstruction(
    employeeId: number,
    payload: PaymentInstructionCreatePayload
  ): Promise<PaymentInstruction> {
    const response = await httpService.post<PaymentInstruction>(
      `/api/admin/employees/${employeeId}/payment-instruction/`,
      payload
    );
    return response.data;
  }

  async createMyPaymentInstruction(
    payload: PaymentInstructionCreatePayload
  ): Promise<PaymentInstruction> {
    const response = await httpService.post<PaymentInstruction>(
      '/api/employees/me/payment-instruction/',
      payload
    );
    return response.data;
  }

  async updatePaymentInstruction(
    employeeId: number,
    payload: PaymentInstructionCreatePayload
  ): Promise<PaymentInstruction> {
    const response = await httpService.put<PaymentInstruction>(
      `/api/admin/employees/${employeeId}/payment-instruction/`,
      payload
    );
    return response.data;
  }

  async updateMyPaymentInstruction(
    payload: PaymentInstructionCreatePayload
  ): Promise<PaymentInstruction> {
    const response = await httpService.put<PaymentInstruction>(
      '/api/employees/me/payment-instruction/',
      payload
    );
    return response.data;
  }
}

export default new PaymentInstructionService();
